// Repères pratiques propres à chaque activité : ce sont des points à déclarer
// et à vérifier dans une offre, pas une liste de garanties acquises.
export const TRADE_DECISIONS = {
  vrd: {
    summary: "Pour une entreprise de VRD, l'étude d'assurance commence par la nature des réseaux et des voiries réalisés. Précisez leur rattachement à un bâtiment : tous les ouvrages de génie civil ne relèvent pas de la même obligation d'assurance.",
    activities: [
      "Distinguer réseaux humides, réseaux secs, assainissement et raccordements.",
      "Décrire les voiries, plateformes et ouvrages de drainage réalisés, ainsi que leur lien avec une construction.",
      "Signaler terrassement, compactage et éventuels travaux de soutènement.",
      "Vérifier les garanties relatives aux réseaux existants et aux interventions en sous-traitance.",
    ],
  },
  macon: {
    summary: "Pour un maçon, la mention générale « gros œuvre » ne suffit pas à comparer deux contrats. Fondations, ouverture de murs porteurs, extension et reprise en sous-œuvre doivent correspondre aux activités acceptées par l'assureur.",
    activities: [
      "Séparer construction neuve, rénovation et extension dans le descriptif d'activité.",
      "Signaler les reprises en sous-œuvre, fondations spéciales et travaux sur murs porteurs.",
      "Décrire les ouvrages enterrés et les travaux d'étanchéité éventuellement réalisés.",
      "Vérifier que vos techniques et vos chantiers prévus entrent dans les limites du contrat.",
    ],
  },
  "charpentier-bois": {
    summary: "Un charpentier bois doit distinguer la pose de charpente, la conception et la réalisation d'ossatures porteuses. Une activité acceptée pour des fermettes ne permet pas de présumer l'acceptation d'une maison à ossature bois ou d'une surélévation.",
    activities: [
      "Déclarer charpente traditionnelle, fermettes et structures en lamellé-collé selon vos travaux.",
      "Préciser qui réalise les études de structure et les notes de calcul.",
      "Signaler maisons à ossature bois, extensions et surélévations.",
      "Vérifier la prise en compte du levage et des dommages aux parties existantes.",
    ],
  },
  "charpentier-metallique": {
    summary: "L'assurance d'un charpentier métallique s'étudie selon les structures fabriquées, leur dimension et les missions de montage. La fabrication en atelier, les études et la pose sur chantier doivent être décrites séparément.",
    activities: [
      "Lister ossatures acier, bâtiments industriels, passerelles et mezzanines réalisés.",
      "Préciser la part de conception, de fabrication et de montage.",
      "Décrire les assemblages, les opérations de soudage et le recours au levage.",
      "Signaler les interventions sur une structure existante et les travaux sous-traités.",
    ],
  },
  terrassier: {
    summary: "Pour un terrassier, préparer un terrain, réaliser des fouilles de fondation et construire un soutènement correspondent à des interventions différentes. Décrivez la destination des terrassements pour faire vérifier le champ de la décennale et les garanties de chantier.",
    activities: [
      "Distinguer décaissement, fouilles, remblaiement et compactage.",
      "Préciser si vous réalisez fondations, drainage ou murs de soutènement.",
      "Décrire les interventions à proximité de bâtiments et de réseaux existants.",
      "Vérifier les garanties des engins et les dommages aux tiers, distinctes de la décennale.",
    ],
  },
  couvreur: {
    summary: "Un couvreur doit faire correspondre son contrat aux matériaux et aux techniques effectivement posés. Couverture, zinguerie, étanchéité de toiture-terrasse et pose de panneaux solaires sont des activités à distinguer dans la demande.",
    activities: [
      "Déclarer les couvertures travaillées : tuiles, ardoises, zinc, bac acier ou autres procédés.",
      "Préciser si vous réalisez l'étanchéité de toitures-terrasses et avec quels systèmes.",
      "Signaler isolation en toiture, fenêtres de toit et interventions photovoltaïques.",
      "Vérifier les garanties de chantier pendant la dépose et la mise hors d'eau provisoire.",
    ],
  },
  facadier: {
    summary: "Le ravalement décoratif et les travaux d'imperméabilisation n'ont pas la même fonction dans une façade. Pour obtenir une proposition pertinente, distinguez les systèmes appliqués, le traitement des fissures et les éventuels travaux d'isolation extérieure.",
    activities: [
      "Séparer nettoyage, ravalement décoratif, enduits et imperméabilisation.",
      "Décrire les supports et les techniques de traitement des fissures.",
      "Signaler l'ITE, le bardage et leurs modes de fixation si vous les réalisez.",
      "Vérifier les conditions relatives au travail en hauteur et aux dommages à l'existant.",
    ],
  },
  "menuisier-interieur": {
    summary: "La menuiserie intérieure recouvre aussi bien le mobilier que des escaliers ou des ouvrages intégrés au bâtiment. L'étude doit distinguer ces travaux : la seule fixation d'un élément ne permet pas de conclure à une garantie décennale.",
    activities: [
      "Séparer fabrication en atelier, livraison et pose sur chantier.",
      "Déclarer escaliers, portes, agencements et ouvrages porteurs selon votre activité.",
      "Préciser les techniques de pose des parquets : collée, clouée ou flottante.",
      "Vérifier les garanties après livraison et les dommages aux biens confiés.",
    ],
  },
  "menuisier-exterieur": {
    summary: "Pour un menuisier extérieur, une pose en construction neuve et le remplacement d'une fenêtre sur existant doivent être distingués. Décrivez les produits, les fixations et l'étendue de la dépose afin de faire vérifier les garanties applicables.",
    activities: [
      "Lister fenêtres, baies, portes, volets et portails réellement posés.",
      "Préciser les matériaux, les dimensions particulières et les ensembles vitrés.",
      "Distinguer pose en neuf, rénovation sur dormant conservé et dépose totale.",
      "Signaler les travaux de maçonnerie, d'étanchéité périphérique et les motorisations.",
    ],
  },
  "chauffagiste-climaticien": {
    summary: "Pour une PAC, une chaudière ou une climatisation, il faut distinguer la création d'une installation et l'ajout d'un équipement sur un bâtiment existant. La présence d'une attestation décennale ne suffit pas à établir que chaque intervention de chauffage est garantie.",
    activities: [
      "Déclarer chauffage, PAC, climatisation, ventilation et maintenance séparément.",
      "Préciser les travaux de réseaux, de planchers chauffants et les interventions sur le gaz.",
      "Distinguer installations neuves et remplacements d'appareils sur existant.",
      "Vérifier les garanties de responsabilité après travaux pour les équipements hors champ décennal.",
    ],
  },
  plombier: {
    summary: "Un plombier doit distinguer les réseaux intégrés au bâtiment, les installations sanitaires et le dépannage courant. Pour comparer les offres, vérifiez à la fois les travaux déclarés et le traitement des dommages causés par une fuite pendant ou après l'intervention.",
    activities: [
      "Décrire les réseaux d'alimentation et d'évacuation, encastrés ou apparents.",
      "Signaler salles de bains, douches et travaux d'étanchéité associés.",
      "Déclarer séparément chauffage, gaz et recherche de fuite si vous les pratiquez.",
      "Vérifier les garanties des dommages à l'existant et de responsabilité après travaux.",
    ],
  },
  fumiste: {
    summary: "La construction d'un conduit, le tubage, la pose d'un insert et le ramonage doivent être décrits séparément à l'assureur. Un appareil ajouté sur existant n'entre pas automatiquement dans les garanties légales de construction.",
    activities: [
      "Distinguer création de conduits, tubage et raccordement d'appareils.",
      "Préciser les poêles, inserts et combustibles concernés.",
      "Signaler les travaux de maçonnerie, les traversées de toiture et l'étanchéité associée.",
      "Vérifier la prise en compte du ramonage, de l'entretien et de la responsabilité après intervention.",
    ],
  },
  electricien: {
    summary: "Pour un électricien, la demande doit distinguer installations complètes, rénovation et dépannage. Les bornes de recharge, le photovoltaïque ou les systèmes de sécurité ne doivent pas être supposés inclus dans une simple mention « électricité générale ».",
    activities: [
      "Décrire courants forts, courants faibles, tableaux et réseaux encastrés.",
      "Préciser la part de construction neuve, de rénovation et de dépannage.",
      "Signaler bornes IRVE, photovoltaïque, domotique et alarmes si vous les installez.",
      "Vérifier les garanties après intervention et les dommages aux équipements du client.",
    ],
  },
  carreleur: {
    summary: "Le devis d'assurance d'un carreleur doit préciser les supports, les techniques de pose et les travaux d'étanchéité. Une douche à l'italienne ou une terrasse ne doit pas être décrite comme une simple pose décorative intérieure.",
    activities: [
      "Distinguer pose collée, pose scellée, chapes et préparation des supports.",
      "Déclarer les systèmes de protection à l'eau et d'étanchéité réellement mis en œuvre.",
      "Préciser douches, terrasses, piscines et autres réalisations particulières.",
      "Signaler grands formats et pose sur plancher chauffant, avec les procédés utilisés.",
    ],
  },
  serrurier: {
    summary: "Un serrurier qui réalise du dépannage et un métallier qui pose des garde-corps n'exposent pas leur entreprise aux mêmes risques. Présentez séparément les interventions de serrurerie et les ouvrages participant à la sécurité ou à la structure du bâtiment.",
    activities: [
      "Séparer ouverture de portes, remplacement de serrures et blindage.",
      "Déclarer garde-corps, escaliers et structures métalliques réalisés.",
      "Préciser fabrication, soudage, pose et modes de fixation au bâti.",
      "Signaler portails motorisés, fermetures industrielles et interventions en hauteur.",
    ],
  },
  peintre: {
    summary: "Pour un peintre, l'assurance doit distinguer la décoration des revêtements techniques qui protègent le bâtiment. La peinture esthétique ne relève pas automatiquement de la décennale ; l'imperméabilisation ou certains systèmes de façade demandent une étude spécifique.",
    activities: [
      "Séparer peinture intérieure, extérieure et travaux d'imperméabilisation.",
      "Décrire les revêtements techniques et les supports traités.",
      "Signaler ravalement, sols en résine et traitements particuliers s'ils sont pratiqués.",
      "Vérifier les garanties pour projections, taches et dommages aux locaux pendant le chantier.",
    ],
  },
  vitrier: {
    summary: "Le remplacement d'une vitre et la réalisation d'une façade vitrée ne se décrivent pas de la même façon dans un contrat. Précisez la fonction des vitrages, leurs fixations et votre rôle dans la conception pour faire vérifier les garanties adaptées.",
    activities: [
      "Distinguer remplacement ponctuel, miroiterie et ensembles vitrés de façade.",
      "Signaler vitrages de sécurité, garde-corps vitrés et verrières.",
      "Préciser les travaux d'étanchéité, les fixations et la pose en hauteur.",
      "Vérifier les garanties concernant manutention, casse et biens confiés.",
    ],
  },
  "revetements-souples": {
    summary: "Pour les sols PVC, linoléums et moquettes, le support et la destination des locaux comptent dans l'étude d'assurance. Décrivez l'ensemble des travaux de préparation et de pose : un défaut esthétique isolé n'est pas, à lui seul, un désordre décennal.",
    activities: [
      "Lister les revêtements posés et les modes de pose, collés ou libres.",
      "Préciser ragréage, préparation des supports et éventuelles chapes.",
      "Signaler locaux humides, établissements recevant du public et sols techniques.",
      "Vérifier la prise en compte des dommages au support et de la responsabilité après travaux.",
    ],
  },
  "platrier-plaquiste": {
    summary: "Un plâtrier plaquiste doit préciser si ses travaux portent sur des cloisons, des plafonds ou des complexes d'isolation. Les exigences de résistance au feu, d'acoustique et de fixation peuvent modifier la description du risque à assurer.",
    activities: [
      "Déclarer cloisons, doublages, plafonds suspendus et plâtrerie traditionnelle.",
      "Préciser les complexes isolants et les systèmes mis en œuvre.",
      "Signaler ouvrages coupe-feu, locaux humides et interventions en ERP.",
      "Vérifier les limites concernant hauteur, fixations et travaux associés.",
    ],
  },
  isolation: {
    summary: "Pour l'isolation intérieure, décrivez le matériau, la technique de pose et la partie du bâtiment traitée. Une attestation mentionnant l'isolation doit être rapprochée des procédés effectivement utilisés, notamment pour le soufflage, l'insufflation ou la projection.",
    activities: [
      "Distinguer isolation des combles, des murs, des rampants et des planchers.",
      "Préciser les matériaux et les techniques : panneaux, rouleaux, soufflage ou projection.",
      "Décrire les travaux de pare-vapeur, d'étanchéité à l'air et les interfaces avec la ventilation.",
      "Signaler les procédés particuliers et vérifier leur acceptation dans le contrat.",
    ],
  },
  "isolation-exterieure": {
    summary: "L'assurance d'une entreprise d'ITE doit correspondre au système complet posé sur la façade. Enduit sur isolant et bardage rapporté appellent un descriptif précis des fixations, des supports et du traitement des points singuliers.",
    activities: [
      "Distinguer isolation sous enduit, bardage ventilé et autres systèmes d'ITE.",
      "Préciser isolants, fixations, supports et procédés employés.",
      "Décrire les traitements des tableaux de fenêtres, soubassements et raccords de toiture.",
      "Vérifier les limites relatives aux hauteurs, aux bâtiments et aux techniques acceptées.",
    ],
  },
  agenceur: {
    summary: "Un agenceur doit séparer mobilier, aménagement intérieur et ouvrages structurels dans sa demande d'assurance. Si vous coordonnez aussi les autres corps de métier, indiquez cette mission et les travaux sous-traités pour éviter une description incomplète de votre activité.",
    activities: [
      "Distinguer conception, fabrication, livraison et pose des agencements.",
      "Signaler escaliers, mezzanines et modifications du bâti.",
      "Déclarer les interventions sur plomberie, électricité ou ventilation, réalisées ou sous-traitées.",
      "Préciser coordination de chantier, établissements recevant du public et exigences particulières.",
    ],
  },
};
